(function() {
    angular
        .module("app")
        .controller("EventModalController", EventModalController)

    EventModalController.$inject = [
        "$stateParams",
        "$state",
        "$scope",
        "$uibModalInstance",
        "$filter",
        "messageBoardsService",
        "userMessagingService",
        "eventsService",
        "eventID",
        "messageBoardTimezone",
        "messageBoard",
        "messagePreviewService"
    ]

    function EventModalController(
        $stateParams,
        $state,
        $scope,
        $uibModalInstance,
        $filter,
        messageBoardsService,
        userMessagingService,
        eventsService,
        eventID,
        messageBoardTimezone,
        messageBoard,
        messagePreviewService
    ){
        "use strict"

        var date = new Date()

        /**
            $scope variables
         **/

        $scope.eventFormData = {}
        $scope.dtStart = {}
        $scope.dtEnd = {}
        $scope.sort_by_title = "Message Name"
        $scope.sort_by = "name"
        $scope.sort_direction = "ASC"
        $scope.filter_by = ""
        $scope.page = 1
        $scope.perPage = 500
        $scope.messages = []
        $scope.messageBoardTimeZone = messageBoardTimezone
        $scope.messageBoard = messageBoard

        const generatePreviews = async () => {

            for (const message of $scope.messages) {
                if (message.hasOwnProperty("multi")) {
                    $scope.previewController = await messagePreviewService.getController($scope.messageBoard)
                    messagePreviewService.generatePreviewFromMulti($scope.previewController, message.multi, "previewContainer-" + message.id)
                }
            }
        }

        /**
            Get message board messages
         **/
        var getAllMessages = function() {
            messageBoardsService.getMessageBoardMessages($stateParams.message_board_id, $scope.page, $scope.perPage, $scope.sort_by, $scope.sort_direction, $scope.filter_by, async (data) => {
                $scope.messages = data
                await generatePreviews()
            })
        }
        getAllMessages()

        if(eventID) {
            $scope.isEventEdit = true
            $scope.modalType = "Edit"

            eventsService.getEvent($stateParams.message_board_id, eventID).then(function(data) {
                $scope.eventFormData = {
                    event: {
                        recurrence_attributes: {
                            start_day: angular.toJson(data.recurrence.start_day),
                            start_hour: angular.toJson(data.recurrence.start_hour),
                            start_minute: angular.toJson(data.recurrence.start_minute),
                            end_day: angular.toJson(data.recurrence.end_day),
                            end_hour: angular.toJson(data.recurrence.end_hour),
                            end_minute: angular.toJson(data.recurrence.end_minute),
                            start_date: $filter("date")(data.recurrence.start_date, "yyyy-MM-dd"),
                            end_date: $filter("date")(data.recurrence.end_date, "yyyy-MM-dd"),
                            type: data.recurrence.type
                        },
                        start_message_id: angular.toJson(data.start_message_id),
                        end_message_id: angular.toJson(data.end_message_id)
                    }
                }

                $scope.dtMin = new Date($filter("date")(data.recurrence.start_date, "yyyy"), ($filter("date")(data.recurrence.start_date, "MM") - 1), $filter("date")(data.recurrence.start_date, "dd"))

                if(data.recurrence.end_date) {
                    $scope.dtMax = new Date($filter("date")(data.recurrence.end_date, "yyyy"), ($filter("date")(data.recurrence.end_date, "MM") - 1), $filter("date")(data.recurrence.end_date, "dd"))
                }
            })
        } else {
            $scope.modalType = "New"
            $scope.eventFormData = {
                event: {
                    recurrence_attributes: {
                        start_day: "0",
                        start_hour: "0",
                        start_minute: "0",
                        end_day: "0",
                        end_hour: "0",
                        end_minute: "0",
                        start_date: $filter("date")(date, "yyyy-MM-dd"),
                        end_date: $filter("date")(date, "yyyy-MM-dd"),
                        type: "weekly"
                    },
                    start_message_id: "",
                    end_message_id: ""
                }
            }
        }

        gtag("event", "create_schedule", { action: "begin", device_id: $scope.messageBoard.device.id, event_id: eventID })

        /**
            Event: Create
         **/
        $scope.createEvent = function() {
            $scope.submitted = true
            if ($scope.createEventForm.$valid) {

                formatDates($scope.dtMin, $scope.dtMax)

                eventsService.createEvent(
                    $stateParams.message_board_id,
                    $scope.eventFormData,
                    function(event) {
                        //Success
                        gtag("event", "create_schedule", { action: "complete", device_id: $scope.messageBoard.device.id, event_id: event.id })

                        $state.go($state.$current, null, { reload: true }).then(() => {
                            userMessagingService.success("Event Successfully Created")
                        })
                    },
                    function(error_messages) {
                        //Failure
                        userMessagingService.error("Event Creation Failure: " + error_messages)
                    }
                )

                $uibModalInstance.close()
            }
        }

        /**
            Event: Edit
         **/
        $scope.editEvent = function() {
            $scope.submitted = true

            formatDates($scope.dtMin, $scope.dtMax)

            if ($scope.createEventForm.$valid) {
                eventsService.editEvent(
                    $stateParams.message_board_id,
                    eventID,
                    $scope.eventFormData,
                    function() {
                        //Success
                        gtag("event", "create_schedule", { action: "complete", device_id: $scope.messageBoard.device.id, event_id: eventID })

                        $state.go($state.$current, null, {reload: true}).then(() => {
                            userMessagingService.success("Event Successfully Edited")
                        })
                    },
                    function(error_messages) {
                        //Failure
                        userMessagingService.error("Event Edit Failure: " + error_messages)
                    }
                )

                $uibModalInstance.close()
            }
        }

        var formatDates = function(startDate, endDate) {
            $scope.eventFormData.event.recurrence_attributes.start_date = $filter("date")(startDate, "yyyy-MM-dd")
            $scope.eventFormData.event.recurrence_attributes.end_date = $filter("date")(endDate, "yyyy-MM-dd")
        }

        /**
            Event: Delete
         **/
        $scope.deleteEvent = function() {
            eventsService.deleteEvent(
                $stateParams.message_board_id,
                eventID,
                function() {
                    //Success
                    gtag("event", "delete_schedule", { device_id: $scope.messageBoard.device.id, event_id: eventID })

                    $state.go($state.$current, null, { reload: true }).then(() => {
                        userMessagingService.success("Event Successfully Deleted")
                    })
                },
                function(error) {
                    //Failure
                    userMessagingService.error(error)
                }
            )
        }

        /**
            Datepicker config
         **/
        $scope.minStatus = {
            opened: false
        }
        $scope.maxStatus = {
            opened: false
        }

        $scope.today = function() {
            $scope.dt = new Date()
        }
        $scope.today()

        $scope.dtMin = new Date()

        $scope.clear = function() {
            $scope.dt = null
        }

        $scope.setMinDate = function(year, month, day) {
            $scope.minDate = new Date(year, month, day)
        }
        $scope.setMaxDate = function(year, month, day) {
            $scope.maxDate = new Date(year, month, day)
        }

        $scope.openMin = function($event) {
            $scope.minStatus.opened = true
        }

        $scope.openMax = function($event) {
            $scope.maxStatus.opened = true
        }

        $scope.minDateOptions = {
            formatYear: "yy",
            startingDay: 1,
            showWeeks: false,
            maxDate: $scope.dtMax
        }

        $scope.maxDateOptions = {
            formatYear: "yy",
            startingDay: 1,
            showWeeks: false,
            minDate: $scope.dtMin
        }

        $scope.$watch("dtMin", function() {
            $scope.maxDateOptions.minDate = $scope.dtMin
        })

        $scope.$watch("dtMax", function() {
            $scope.minDateOptions.maxDate = $scope.dtMax
        })

        $scope.format = "MM/dd/yyyy"

        $scope.ok = function() {
            $uibModalInstance.close()
        }

        $scope.cancel = function() {
            gtag("event", "create_schedule", { action: "cancel", device_id: $scope.messageBoard.device.id, event_id: eventID })
            $uibModalInstance.dismiss("cancel")
        }

        $scope.$on('$destroy', () => {
            if ($scope.previewController) {
                $scope.previewController.dispose()
            }
        })
    }
})()
